webpackJsonp([141700697014215],{

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreExtractAction = __webpack_require__(54);
	
	var _LoreExtractAction2 = _interopRequireDefault(_LoreExtractAction);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreExtractAction2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'extract action'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'CLI command to extract one or more of the ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/actions/' },
	        'actions'
	      ),
	      ' generated by the framework into your project. This will allow you to see the code that gets executed, and change it if needed.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To use this command, you need to specify the name of the model you\'d like to extract an action for, as well as the name of the action you\'d like to extract.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore extract action [model]/[action]\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For example, to extract the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'create'
	      ),
	      ' action for the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'post'
	      ),
	      ' model, you would run the command ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore extract action post/create'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you do NOT specify an action, the command will extract ALL actions for that model. For example, this command:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore extract action post\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Will extract all actions for the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'post'
	      ),
	      ' model, and create the files below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      -src\n       |-actions\n         |-post\n           |-create.js\n           |-destroy.js\n           |-find.js\n           |-get.js\n           |-update.js\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cli-lore-extract-action-index-js-49c76c696efdcdc21a93.js